import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProactiveSupportOpenIssuesRoute: InvariantJiraRoute = {
	name: 'servicedesk-proactive-support-open-issues',
	path: '/jira/servicedesk/projects/:projectKey/proactive-support/open-issues',
	exact: true,
};
